// extracted by mini-css-extract-plugin
module.exports = {"container":"FormikSection_container__3J8GY","pane":"FormikSection_pane__2M11B","heading":"FormikSection_heading__1esiT"};